'use strict';

import keymirror from 'keymirror';

export default keymirror({
    FULFILLMENT_PROVIDER_LOAD: null,
    FULFILLMENT_PROVIDER_RELOAD: null,
    FULFILLMENT_PROVIDER_HYDRATE: null
});
